<template>
  <div>
    <div class="container">
      <h4 class="title">Match Schedule</h4>
      <ul>
        <li v-for="(i, index) in createMonthArr" :key="i.index">
          <a
            href="#"
            class="anchor"
            :data-link="i.month"
            :class="((new Date().getMonth() + 1) == i.shortMonth )? 'active': ''"
          >
            <span class="year">{{i.year}}</span>
            <span>{{i.month}}</span>
          </a>
        </li>
      </ul>
      <div class="accordions">
        <div class="content Accordion" v-for="(i, index) in createMonthArr" :key="i.index">
          <div
            class="Expander"
            :id="i.month"
            :data-block="i.month"
            :class="((new Date().getMonth() + 1) == i.shortMonth )? 'active': ''"
          >
            <div class="Expander__trigger" :data-link="i.month">
              <h6>{{ i.fullmonth }}</h6>
              <svg
                width="11"
                height="8"
                viewBox="0 0 11 8"
                fill="none"
                class="Expander__trigger-Icon"
              >
                <path
                  d="M5.07078 0.542219L0.17573 5.98126C0.0624223 6.10706 0 6.27499 0 6.45405C0 6.63311 0.0624223 6.80104 0.17573 6.92684L0.536134 7.32739C0.770977 7.58803 1.15267 7.58803 1.38715 7.32739L5.49772 2.76009L9.61285 7.33245C9.72616 7.45825 9.8772 7.52771 10.0383 7.52771C10.1995 7.52771 10.3506 7.45825 10.464 7.33245L10.8243 6.93191C10.9376 6.80601 11 6.63818 11 6.45912C11 6.28006 10.9376 6.11213 10.8243 5.98633L5.92475 0.542219C5.81108 0.416122 5.65932 0.346864 5.49799 0.347261C5.33603 0.346864 5.18436 0.416122 5.07078 0.542219Z"
                  fill="#363636"
                />
              </svg>
            </div>
            <app-matches :matches="matches" :i="i"></app-matches>
          </div>
        </div>
      </div>
    </div>
    <BottomSection></BottomSection>
  </div>
</template>
<script>
import moment from "moment";
import ScheduleMatches from "../components/ScheduleMatches.vue";

const url = process.env.VUE_APP_URL;
const BottomSection = () => import("@/components/shared/BottomSection");

export default {
  data() {
    return {
      active: false,
    };
  },
  computed: {
    createMonthArr() {
      var date = new Date(),
        mas = [];

      var masEmpty = [];
      for (var i = 1; i < 6; i++) {
        var newD = new Date(
          new Date().getFullYear(),
          new Date().getMonth() + i,
          0
        );
        var fullmonth = moment(newD).format("MMMM"),
          month = moment(newD).format("MMM"),
          shortMonth = moment(newD).format("M"),
          year = moment(newD).format("YYYY");

        var elementPush = {
          fullmonth: null,
          month: null,
          shortMonth: null,
          year: null,
        };
        elementPush.fullmonth = fullmonth;
        elementPush.month = month;
        elementPush.shortMonth = shortMonth;
        elementPush.year = year;
        masEmpty.push(elementPush);
      }
      masEmpty.reverse();
      mas = mas.concat(masEmpty);

      for (var i = 0; i < 4; i++) {
        var newD = new Date();

        newD = new Date(newD.getFullYear(), newD.getMonth() - i, 0);

        var fullmonth = moment(newD).format("MMMM"),
          month = moment(newD).format("MMM"),
          shortMonth = moment(newD).format("M"),
          year = moment(newD).format("YYYY");

        var elementPush = { fullmonth: null, month: null, year: null };
        elementPush.fullmonth = fullmonth;
        elementPush.month = month;
        elementPush.shortMonth = shortMonth;
        elementPush.year = year;

        mas.push(elementPush);
      }
      return mas.reverse();
    },
    matches() {
      var arr = this.$store.getters.match,
        newArr = [];
      arr.map((elem) => {
        var today = new Date();
        today.setHours(today.getHours() - 2);

        if (Date.parse(elem.eventDate) < Date.parse(today)) {
          elem.time = "past";
          newArr.push(elem);
        } else if (Date.parse(elem.eventDate) > Date.parse(today)) {
          elem.time = "future";
          newArr.push(elem);
        }
      });
      return newArr;
    },
  },
  methods: {
    setMatch() {
      this.axios
        .get(url + "/matches", {
          headers: {
            "Access-Control-Allow-Origin": "*",
            accept: "application/json",
          },
        })
        .then((response) => {
          const payload = response.data;
          this.$store.dispatch("setMatch", payload);
        });
    },
    clickes() {
      setTimeout(function () {
        var item = $(".Expander.active");
        item.find(".Expander__body").slideToggle(500);

        var thisOffsetTop = item.offset().top,
          headerHeight = $(".header").height();

        $("html, body").animate(
          {
            scrollTop: thisOffsetTop - headerHeight - 20,
          },
          700
        );
      }, 500);
      $(".anchor").on("click", function (e) {
        e.preventDefault();
        if ($(this).hasClass("active")) {
          return false;
        } else {
          $(".anchor").each(function () {
            $(this).removeClass("active");
          });
          $(this).toggleClass("active");
          var thisAttr = $(this).attr("data-link");
          $(".Expander").each(function () {
            var thisData = $(this).attr("data-block");
            $(this).removeClass("active");
            $(this).find(".Expander__body").slideUp(500);

            if (thisData == thisAttr) {
              $(this).toggleClass("active");
              $(this).find(".Expander__body").slideToggle(500);

              setTimeout(() => {
                var thisOffsetTop = $(this).offset().top;
                var headerHeight = $(".header").height();
                $("html, body").animate(
                  {
                    scrollTop: thisOffsetTop - headerHeight - 20,
                  },
                  700
                );
              }, 500);
            }
          });
        }
      });
      $(".Expander__trigger").on("click", function (e) {
        e.preventDefault();
        var expanderElem = $(this).parent();
        var headerHeight = $(".header").height();
        var thisAttr = $(this).parent().attr("data-block");

        if (expanderElem.hasClass("active")) {
          $(".anchor").each(function () {
            $(this).removeClass("active");
          });
          $(".Expander").each(function () {
            $(this).removeClass("active");
            $(this).find(".Expander__body").slideUp(500);
          });
        } else {
          $(".anchor").each(function () {
            var thisData = $(this).attr("data-link");
            $(this).removeClass("active");

            if (thisData == thisAttr) {
              $(".Expander").each(function () {
                $(this).removeClass("active");
                $(this).find(".Expander__body").slideUp(500);
              });
              expanderElem.addClass("active");
              expanderElem.find(".Expander__body").slideDown(500);

              $(this).toggleClass("active");
              setTimeout(() => {
                var thisOffsetTop = expanderElem.offset().top;
                $("html, body").animate(
                  {
                    scrollTop: thisOffsetTop - headerHeight - 20,
                  },
                  700
                );
              }, 500);
            }
          });
        }
      });
    },
  },
  mounted() {
    this.setMatch();
    this.clickes();
  },
  components: {
    "app-matches": ScheduleMatches,
    BottomSection,
  },
};
</script>
<style lang="scss" scoped>
.container {
  padding: 9rem 0 5rem;
  @media only screen and (max-width: 650px) {
    padding: 3rem 0 5rem;
  }
  h4 {
    margin-bottom: 6.5rem;
    @media only screen and (max-width: 768px) {
      margin-bottom: 4rem;
    }
  }
}
.Accordion {
  overflow: hidden;
}
ul {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  //flex-wrap: wrap;
  width: 100%;
  border: 1px solid #f2f2f2;
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
  margin-bottom: 5rem;
  @media only screen and (max-width: 768px) {
    width: calc(100% + 15px);
    padding-right: 15px;
    overflow-y: scroll;
  }
  li {
    min-width: calc(100% / 9);
    background: #fff;
    text-align: center;
    border-left: 1px solid #f2f2f2;
    @media only screen and (max-width: 768px) {
      min-width: calc(100% / 5.5);
    }
    @media only screen and (max-width: 599px) {
      min-width: calc(100% / 2.5);
    }
    a {
      width: 100%;
      text-align: center;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -ms-flex-direction: column;
      flex-direction: column;
      padding: 1.3rem 0 1.9rem;
      position: relative;
      cursor: pointer;
      transition: all 0.3s ease-in-out;
      span {
        font-size: 1.4rem;
        font-weight: 700;
        line-height: 1.5rem;
        color: #a8a8a8;
        text-transform: uppercase;
        &.year {
          font-size: 0.9rem;
          font-weight: 500;
        }
      }
      &:after {
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        width: 0;
        height: 3px;
        background-color: #fdc65a;
        border-top-right-radius: 2px;
        border-top-left-radius: 2px;
        content: "";
        transition: all 0.3s ease-in-out;
      }
      &:hover,
      &.active {
        span {
          color: #363636;
        }
        &:after {
          width: 100%;
        }
      }
    }
    &:first-of-type {
      border: none;
    }
  }
}

.Expander {
  margin-bottom: 3rem;
  &__trigger {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    cursor: pointer;
    padding: 2.6rem 3rem;
    background: #eff1f8;
    border-bottom: 1px solid #efefef;
    @media only screen and (max-width: 1199px) {
      padding: 2rem 1.5rem;
    }
    h6 {
      font-size: 2rem;
      line-height: 1.7rem;
      text-transform: capitalize;
      margin-right: 1.5rem;
      @media only screen and (max-width: 768px) {
        font-size: 1.5rem;
      }
    }
    &-Icon {
      transition: transform 0.3s ease-in-out;
      transform: rotate(180deg);
      &.open {
        fill: #283891;
        transform: rotate(0);
      }
    }
    &:hover {
      color: #283891;
      svg path {
        fill: #283891;
      }
    }
    &.active {
      //color #777
      border-bottom-color: #283891;
    }
    svg {
      width: auto;
    }
  }
  &__body {
    display: none;
    overflow: hidden;
    background: #fff;
  }
  &.active {
    .Expander__trigger {
      color: #283891;
      svg {
        transform: rotate(0);
      }
      svg path {
        fill: #283891;
      }
    }
  }
}
</style>


        